import { Pressable } from 'react-native'
import { getSpotlightProxyPositionStyle } from './GuestWalkthroughOverlay.styles'
import type { TargetRect } from '../../src/create/types/guestWalkthrough.types'

export function SpotlightProxy({
  targetRect,
  onPress,
  accessibilityLabel,
  proxyStyle,
}: {
  targetRect: TargetRect
  onPress: () => void
  accessibilityLabel: string
  proxyStyle: object
}) {
  return (
    <Pressable
      style={[proxyStyle, getSpotlightProxyPositionStyle(targetRect)]}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    />
  )
}
